import React from 'react'
import { Chat } from '../../components/Chat'

const ChatView = () => {
  return (
    <Chat />
  )
}

export { ChatView }